<template>
    <div class="row">
        <snappy-table
                ref="table"
                :endpoint="'vessels/' + vesselId + '/campaigns/' + campaign.id + '/audiences'"
                :columns="['status','name','members','missing_direct_subscribers']"
                :templated-slot-names="['status', 'missing_direct_subscribers']"
                :headings="['Status', 'Group', 'All Contacts', 'Missing Contacts']"
                :filter-values="filterValues"
                :filterable-columns="['status', 'name']"
                table-class="subscribers-table"
                record-type="Groups"
        >
            <template #status="{ row }">
                <div class="d-inline-flex">
                    <div @click="handleSubscribers(row)" v-if="row.pending" :class="'subscription-label hoverable label label-default label-'+ row.id">
                      <div class="place-holder unsubscribed cursor-not-allowed">
                        <i class="icon fas fa-spinner fa-spin mr-2" aria-hidden="true"></i> PENDING...
                      </div>
                    </div>
                    <div @click="handleSubscribers(row)" v-else-if="row.status === 'subscribed'" :class="'subscription-label subscribed hoverable label label-default label-'+ row.id">
                      <div class="place-holder subscribed">
                        <i class="icon fas fa-check" aria-hidden="true"></i> SUBSCRIBED
                      </div>
                      <div class="action-wrapper unsubscribe-action">
                        <i class="icon fas fa-times" aria-hidden="true"></i> UNSUBSCRIBE
                      </div>
                    </div>
                    <div v-else-if="row.status === 'unsubscribed'" :class="'subscription-label cursor-not-allowed label label-default label-'+ row.id" v-tooltip="'To protect contacts that may have unsubscribed, you cannot re-subscribe a group that has been marked as unsubscribed.'">
                      <div class="place-holder unsubscribed">
                        <i class="icon fas fa-times" aria-hidden="true"></i> UNSUBSCRIBED
                      </div>
                    </div>
                    <div v-else @click="handleSubscribers(row)" :class="'subscription-label label hoverable label-default label-'+ row.id">
                      <div class="place-holder subscribe-neutral"><i class="icon fas fa-plus" aria-hidden="true"></i></div>
                      <div class="action-wrapper subscribe-neutral hoverable">
                        <i class="icon fas fa-check" aria-hidden="true"></i> SUBSCRIBE
                      </div>
                    </div>
                </div>
            </template>
            <template #missing_direct_subscribers="{ row }">
                <missing-direct-subscribers-cell :audience="row" :loading="missingSubscribersLoading[row.id]" @subscribe="onSubscribeMissingClick(row)">
                </missing-direct-subscribers-cell>
            </template>
        </snappy-table>
    </div>
</template>

<script>
    import SnappyTable from '../SnappyTable';
    import MissingDirectSubscribersCell from '../campaign/groups/MissingDirectSubscribersCell'
    import {confirmationHelper} from '../../utility/confirmationHelper';
    import {subscribeGroupToCampaign} from '../../utility/api/campaign/subscribeGroupToCampaign';
    import {unsubscribeGroupFromCampaign} from '../../utility/api/campaign/unsubscribeGroupFromCampaign';

    export default {
        name: 'campaign-group-listing-table',
        components: {SnappyTable, MissingDirectSubscribersCell},
        methods: {
            handleSubscribers(row) {
                if( row.status === 'subscribed') {
                    let text = "This group is currently subscribed to a campaign. Are you sure you want to unsubscribe this group?";
                    confirmationHelper.warning(text).then( (confirmed) => {
                        if (confirmed) {
                            this.unsubscribeGroupFromCampaign(row);
                        }
                    });
                } else if ( row.status === 'unsubscribed' || row.status === 'group' ) {

                    if( row.status === 'unsubscribed') {
                        let text = "This group is currently unsubscribed from the campaign. Are you sure you want to re-subscribe this group?";
                        confirmationHelper.warning(text).then( (confirmed) => {
                            if (confirmed) {
                                this.subscribeGroupToCampaign(row);
                            }
                        });
                    } else {
                      this.subscribeGroupToCampaign(row);
                    }
                }
            },
            async subscribeGroupToCampaign(group) {
                Vue.set(group, 'pending', true);

                try {
                    await subscribeGroupToCampaign(this.campaign.id, group.id);
                } catch (error) {
                    Vue.set(group, 'pending', false);
                    $.notify('Failed to subscribe the group to this campaign.', 'error');
                }
            },
            async unsubscribeGroupFromCampaign(group) {
                Vue.set(group, 'pending', true);

                try {
                    await unsubscribeGroupFromCampaign(this.campaign.id, group.id);
                    this.refresh();
                } catch (error) {
                    Vue.set(group, 'pending', false);
                    $.notify('Failed to unsubscribe the group from this campaign.', 'error');
                }
            },
            async onSubscribeMissingClick(group) {
                this.missingSubscribersLoading[group.id] = true;
                await this.subscribeGroupToCampaign(group);
                this.missingSubscribersLoading[group.id] = false;
            },
            refresh() {
                this.$refs.table.refresh();
            },
            listenToPusherNotifications() {
                window.addEventListener('message', ({data}) => {
                    if (data && data.type === 'pusherNotification' && data.notification && data.notification.message && data.notification.message.text === 'Your contacts have been successfully subscribed.') {
                        this.refresh();
                    }
                });
            },
        },
        data() {
            return {
                filterValues: {
                    status : [
                        {'id': 'subscribed', 'text': 'Subscribed'},
                        {'id': 'unsubscribed', 'text': 'Unsubscribed'},
                    ]
                },
                missingSubscribersLoading: {}
            };
        },
        props: {
            campaign: {
                type: Object,
                required: true
            },
            vesselId: {
                type: Number,
                required: true
            },
            timezone: {
                type: String,
                required: true
            }
        },
        mounted() {
            this.listenToPusherNotifications();
        }
    }
</script>
